




































































































import { Component, Vue } from 'vue-property-decorator';
import { BvTableFieldArray } from 'bootstrap-vue';
import { IDelivery } from '@/core/models/IDelivery';
import { IDeliveryWeightCorrected } from '@/core/models/IDeliveryWeightCorrected';
import { backendService } from '@/services/backend-service';
import moment from 'moment';
import DeliveryHelper  from '@/core/DeliveryHelper';
import { deliveryComputation }from '@/core/components/deliveryComputation';
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';
import 'moment/locale/pt-br';
moment.locale("nb");

@Component({
  name: 'Deliveries',
  components: {
    VueCtkDateTimePicker,
  },
})
export default class extends Vue {
  sortDesc= false;
  sortDirection= 'asc';
  busyState = true;
  label="Velg måned og år som skal vises:";
  sortBy = 'Time';
  language="nb";
  datePickerRerenderKeyKey = 0
  items: IDeliveryWeightCorrected[] = [];
  filteredDeliveries: IDeliveryWeightCorrected[] = [];
  today = new Date()
  firstDayMonth = new Date(this.today.getFullYear(), this.today.getMonth(), 1);
  filter = null;
  filterDate= { "start": this.firstDayMonth.toISOString(), "end": this.today.toISOString() };
  customShortcut = [
  { key: 'thisMonth', label: 'Denne md ', value: 'month' },
  { key: 'lastMonth', label: 'Forrige md', value: '-month' },
  {
    key: 'last3Months',
    label: 'Siste 3 md',
    value: () => {
      return {
        end: moment(),
        start: moment().add(-3, 'months')
      }
    },
    callback: ({ start, end }) => {
      this.filterDate.end = end;
      this.filterDate.start = start;
    }
  },
  { key: 'thisYear', label: 'Dette året', value: 'year' },
  { key: 'lastYear', label: 'Forrige år', value: '-year' },
  {
  key: 'twoYear',
  label: '2 år',
  value: () => {
    return {
      end: moment(),
      start: moment().add(-2, 'years')
    }
  },
  callback: ({ start, end }) => {
    this.filterDate.end = end;
    this.filterDate.start = start;
  }
  },
  {
    key: 'fiveYear',
    label: '5 år',
    value: () => {
      return {
        end: moment(),
        start: moment().add(-5, 'years')
      }
    },
    callback: ({ start, end }) => {
      this.filterDate.end = end;
      this.filterDate.start = start;
    }
  },
  {
    key: 'allDeliveries',
    label: 'Alle leveranser',
    value: () => {
      return {
        end: moment(),
        start: moment("2015-09-10")
      }
    },
    callback: ({ start, end }) => {
      this.filterDate.end = end;
      this.filterDate.start = start;
    }
  },
  ];
  fields: BvTableFieldArray = [
    {
      key: 'time',
      label: 'Leverensedato',
      sortable: true,
      formatter: (value, key, item) => {
              return moment(value).format('DD-MM-YYYY');
            }
    },
    {
      key: 'bilagsnummer',
      label: 'Bilagsnummer',
    },
    {
      key: 'vekt',
      label: 'Vekt (kg)',
    },
    {
      key: 'correctedHumidity',
      label: 'Korrigert fukt (kg)',
    },
    {
      key: 'computedCorrectedWeigth',
      label: 'Vekt iht. spec (kg)',
    },
    {
      key: 'actions',
      label: 'Handlinger',
    },
  ];

  beforeMount() {
    if (this.$root.$data.DeliveriesFilterDate !== undefined) {
      this.filterDate = this.$root.$data.DeliveriesFilterDate;
    }
  }

  mounted() {
    this.forceVueCtkDateTimePickerComponentToRerender();
    this.load();
  }

  // VueCtkDateTimePicker does not correctly set localization on load, så have to force an update
  // https://github.com/chronotruck/vue-ctk-date-time-picker/pull/263
  // using best practice for update: https://michaelnthiessen.com/force-re-render/
  forceVueCtkDateTimePickerComponentToRerender() {
    this.datePickerRerenderKeyKey += 1;  
  }

  setToLoaded() {
    this.$root.$data.statusMessage = 'Loaded';
  }

  load() {
    this.$root.$data.DeliveriesFilterDate = this.filterDate;
    backendService
      .getDeliveries(new Date(this.filterDate.start), new Date(this.filterDate.end))
      .then(res => {
        this.$root.$data.statusMessage = 'Leveranser hentet!';
        this.buildDataSet(JSON.parse(res.request.response).response)
        this.filteredDeliveries = this.filterUniqeDeliveries();
        this.busyState = false;
      })
      .catch(err => {
        console.log(err);
        this.$root.$data.statusMessage = 'Leveranser ikke funnet!';
      });
  }
  hiddenTest() {
    this.busyState = true
    if (this.filterDate.end == null) this.filterDate.end = this.today.toISOString()
    this.load()
  }

  filterUniqeDeliveries() {
    var filterItems: IDeliveryWeightCorrected[] = [];
    this.items.forEach(element => {
      var dateTime = moment(element.time);
      if (dateTime.isSameOrAfter( this.filterDate.start)) {
        if (dateTime.isSameOrBefore(this.filterDate.end)) {
          filterItems.push(element)
        } 
        else if (this.filterDate.end == null) {
          filterItems.push(element)
        }
      }
      });
      return filterItems;
    }

  buildDataSet(data: IDelivery[]){
    const unique = DeliveryHelper.getUniqueDeliveries(data);
    this.items = unique.map((delivery: IDelivery) => {
      return {
        ...delivery,
        correctedHumidity: delivery.fuktighet > 0 ? deliveryComputation.computeHumidityWeight(delivery.fuktighet, delivery.vekt) : 0,
        computedCorrectedWeigth: delivery.fuktighet > 0 ? deliveryComputation.computedCorrectedWeight(deliveryComputation.computeHumidityWeight(delivery.fuktighet, delivery.vekt), delivery.vekt) : delivery.vekt
      } as IDeliveryWeightCorrected;
    });
  }


  round_to_precision(x: number, precision: number): number {
    var y = +x + (precision === undefined ? 0.5 : precision / 2);
    return y - (y % (precision === undefined ? 1 : +precision));
  }

  sumProperty(name: string): number {
    if(this.filteredDeliveries.length === 0) return 0;
    return this.filteredDeliveries.map(i => i[name]).reduce((prev, curr) => prev + curr);
  }
  // List must be sorted
  firstDate(): string {
    return moment(this.filterDate.start).format('DD-MM-YYYY');
  }
  // List must be sorted
  lastDate(): string {
    return moment(this.filterDate.end).format('DD-MM-YYYY');
  }

  downloadExcelFile(): void {
    const dateFrom = new Date(this.filterDate.start);
    const dateTo = new Date(this.filterDate.end);
    backendService.getExcelFile(dateFrom, dateTo, "delivery");
  }
}
